var _g, _path, _path2, _circle, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_0_19197)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 60,
    r: 50,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.7767 36.6667H60.2234C51.7301 36.6667 46.6667 41.73 46.6667 50.2234V69.7767C46.6667 76.3334 49.6767 80.8367 54.9734 82.54C56.5134 83.0767 58.2867 83.3334 60.2234 83.3334H79.7767C81.7134 83.3334 83.4867 83.0767 85.0267 82.54C90.3234 80.8367 93.3334 76.3334 93.3334 69.7767V50.2234C93.3334 41.73 88.2701 36.6667 79.7767 36.6667ZM89.8334 69.7767C89.8334 74.77 87.8734 77.92 83.9301 79.2267C81.6667 74.77 76.3001 71.5967 70.0001 71.5967C63.7001 71.5967 58.3567 74.7467 56.0701 79.2267H56.0467C52.1501 77.9667 50.1667 74.7934 50.1667 69.8V50.2234C50.1667 43.6434 53.6434 40.1667 60.2234 40.1667H79.7767C86.3567 40.1667 89.8334 43.6434 89.8334 50.2234V69.7767Z",
    fill: "#2445A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0001 50.6667C65.3801 50.6667 61.6467 54.4 61.6467 59.02C61.6467 63.64 65.3801 67.3967 70.0001 67.3967C74.6201 67.3967 78.3534 63.64 78.3534 59.02C78.3534 54.4 74.6201 50.6667 70.0001 50.6667Z",
    fill: "#2445A7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 26,
    r: 16,
    fill: "#17B471"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.287 22.2993C108.674 21.9053 109.307 21.8996 109.701 22.2866C110.064 22.6438 110.097 23.2107 109.796 23.6058L109.713 23.7007L102.838 30.7007C102.477 31.0691 101.901 31.0974 101.506 30.7857L101.412 30.7007L98.2866 27.5189C97.8996 27.1249 97.9053 26.4917 98.2993 26.1047C98.663 25.7475 99.2305 25.7249 99.62 26.0334L99.7134 26.1175L102.125 28.573L108.287 22.2993Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_19197",
    x: 0,
    y: 0,
    width: 140,
    height: 140,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.305882 0 0 0 0 0.34902 0 0 0 0 0.470588 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_19197"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_19197",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSuccess);
export default __webpack_public_path__ + "static/media/user-success.584f88190c9b7395ed745ed6b080e502.svg";
export { ForwardRef as ReactComponent };